import { useBilling } from '@/features/billing/hooks/useBilling';
import { Button, type ButtonProps } from '@/ui';

interface ManageSubscriptionButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const ManageSubscriptionButton = ({
  children,
  onClick,
  ...buttonProps
}: ManageSubscriptionButtonProps) => {
  const { redirectToBillingPortal } = useBilling();

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    await redirectToBillingPortal();
  };

  return (
    <Button onClick={handleClick} {...buttonProps}>
      {children}
    </Button>
  );
};
